import pyClient from '../PyAPI_Config'

async function get(authState: any, path: string) {
  return await pyClient(authState)
    .get<any>('/protocol' + path)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const ProtocolService = {
  get,
}

export default ProtocolService
